import { render } from "./AboutMeInfoContainer.vue?vue&type=template&id=d5a0a552"
import script from "./AboutMeInfoContainer.vue?vue&type=script&lang=js"
export * from "./AboutMeInfoContainer.vue?vue&type=script&lang=js"

import "./AboutMeInfoContainer.vue?vue&type=style&index=0&id=d5a0a552&lang=scss"

import exportComponent from "D:\\Projekty\\Elektromeck\\electro-meck-project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__